export enum BdcCheckPropertyStatusOperation {
  CHECK = 'CHECK',
  OPEN = 'OPEN',
  CLOSE = 'CLOSE',
}

export enum BdcUpdatePropertyStatusReasonType {
  OTHER = 'OTHER',
  SEASON = 'SEASON',
  RENOVATION = 'RENOVATION',
  PROPERTY_NOT_AVAILABLE = 'PROPERTY_NOT_AVAILABLE',
  FULLY_BOOKED = 'FULLY_BOOKED',
  ISSUES_GUESTS = 'ISSUES_GUESTS',
  ISSUES_BOOKING = 'ISSUES_BOOKING',
  STRATEGY = 'STRATEGY',
}

export interface BdcUpdatePropertyStatusReason {
  type?: BdcUpdatePropertyStatusReasonType
  description?: string
}

export interface BdcUpdatePropertyStatusPayload {
  operation: BdcCheckPropertyStatusOperation
  reason?: BdcUpdatePropertyStatusReason
}

export interface BdcGetPropertyStatusResponse {
  status: string
}

export interface BdcCheckPropertyStatus {
  status: string
  errors: string[]
  warnings: string[]
}
